import React from 'react';
import ReactPaginate from 'react-paginate';
import clsx from 'clsx';

import Icon from '../Icon';
import type { Pagination } from '../../hooks/usePaginated';

type PaginatedItemsProps = Pagination & {
  className?: string;
  setPage?: (page: number) => void;
};

type PageParams = { selected: number };

const Paginate: React.FC<PaginatedItemsProps> = ({
  className,

  setPage,
  page = 1,
  totalPages,
}) => {
  const handlePageClick = (e: PageParams) => setPage?.(e.selected + 1);

  return (
    <>
      <ReactPaginate
        className={clsx(className, 'flex gap-x-3 items-center text-medium')}
        disabledClassName="opacity-20 cursor-not-allowed"
        pageClassName="rounded-sm hover:bg-dark cursor-pointer"
        activeClassName="border-2 border-main hover:bg-contrast"
        pageLinkClassName="flex items-center justify-center p-2 size-11"
        nextClassName="hover:bg-dark p-2 rounded-sm"
        previousClassName="hover:bg-dark p-2 rounded-sm"
        breakLabel="..."
        nextLabel={<Icon icon="right" />}
        pageCount={totalPages || 1}
        pageRangeDisplayed={3}
        previousLabel={<Icon icon="left" />}
        renderOnZeroPageCount={null}
        onPageChange={handlePageClick}
        forcePage={page - 1}
      />
    </>
  );
};

export const PaginatePanel: React.FC<PaginatedItemsProps> = props => {
  return (
    <div className="flex justify-end overflow-x-auto">
      <Paginate {...props} />
    </div>
  );
};

export default React.memo(Paginate) as typeof Paginate;
